export const fullStoryBlockList = [
  'purchaseKnownAddress',
  'state',
  'zipCode',
  'firstName',
  'lastName',
  'dateOfBirth',
  'phone',
  'declarationCitizenStatus',
  'address-fields-auto-complete',
]
